import { useGridDefinitions } from "@/controls/ag-grid/components/GridDefinitions";
import { CenteredLazyLoading } from "@/controls/LazyLoading";
import { Paper } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import type { M1ShiftReportStackerBundle } from "../models/M1ShiftReportResponse";
import { useTableData } from "./useTableData";

export const TableM1StackerBundles = ({
	bundles,
}: {
	bundles: M1ShiftReportStackerBundle[];
}) => {
	const { defaultColDef } = useGridDefinitions({});
	const { columnDefs } = useTableData();

	return (
		<Paper
			elevation={2}
			sx={{
				height: "100%",
				width: "100%",
				"& .ag-cell": {
					fontSize: 11,
				},
			}}
		>
			<AgGridReact<M1ShiftReportStackerBundle>
				rowData={bundles || []}
				columnDefs={columnDefs}
				defaultColDef={defaultColDef}
				rowHeight={30}
				headerHeight={34}
				animateRows
				getRowId={(params) => String(params.data.StackerBundleId)}
				loadingOverlayComponent={CenteredLazyLoading}
			/>
		</Paper>
	);
};
